import { ID } from "src/libs/interfaces/layouts"
import { __ } from "src/libs/utilities"
import { HISTORY_TYPE, IHistoryStep, ILanding, ILandingSection, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import localUpdate from "./localUpdate"

//TODO: разные методы делают одно и то же utils/updateSelected
export default function updateSelectedPosition(newValue: any, selectType: SELECT_TYPE): boolean {
    
    // console.log(newValue, selectType)
    
    const selectedLayer : ID         = useLandingStore.getState().selectedLayer
    const currentLanding: ILanding   = useLandingStore.getState().currentLanding
    const currentHistoryStep: number = useLandingStore.getState().currentHistoryStep
    let is = false
    const historyStep: IHistoryStep = {
        data: null,
        prevData: null,
        type: HISTORY_TYPE.SECTION,
        title : __( "Update " + selectType + " position" ),
    }
    const newData: Partial<ILandingStore> = {
        currentLanding: {
            ...currentLanding,
            sections: currentLanding.sections.map(section => {
                if( section.id === selectedLayer ) {
                    historyStep.prevData = JSON.parse( JSON.stringify( section ) )
                    historyStep.data = getNewValue( section, newValue, selectType )
                    return historyStep.data
                }
                return section
            })
        },
        history: [], 
        needUpdate: true,
    } 
    
    
    if( currentHistoryStep > 0) {
        newData.currentHistoryStep = 0
        newData.history = [ historyStep ]
    }
    else {
        newData.history = [ historyStep, ...useLandingStore.getState().history ]
    }   
    localUpdate( newData, "update select position:" )
    return is
}

const getNewValue = ( section:ILandingSection, newValue: any, selectType: SELECT_TYPE ): ILandingSection => {
    switch ( selectType ) {
        case SELECT_TYPE.FLOAT:
            return {
                ...section, 
                floats: section.floats.map(float => {
                    if( selectType === SELECT_TYPE.FLOAT && float.id === newValue.id) {  
                        return {
                            ...float,
                            position: {
                                ...float.position, 
                                ...newValue.position
                            }
                            
                        }
                    } 
                    return float
                })
            }
        case SELECT_TYPE.CONTENT:
            return {
                ...section, 
                data: section.data.map(data => {
                    if( selectType === SELECT_TYPE.CONTENT && data.id === newValue.id) {  
                        return {
                            ...data,
                            position: {
                                ...data.position, 
                                ...newValue.position
                            }
                        }
                    } 
                    return data
                })
            }
        case SELECT_TYPE.TITLE:
            console.log( "getNewValue:", selectType, newValue )

            return  {
                ...section, 
                title: {
                    ...section.title, 
                    position: {
                        ...(section.title?.position || {}),
                        ...newValue 
                    }
                }
            }
        default:
            return section
    }
}